import 'sweetalert2/dist/sweetalert2.min.css'
import Swal from 'sweetalert2'
import { translate } from '@/i18n'

export function useSwalAlert(entryText, entryIcon = null, entryOptions = {}) {
  const swalModal = Swal.mixin({
    customClass: {
      confirmButton: 'btn btn-primary btn-loading mx-3',
      cancelButton: 'btn btn-secondary',
      text: 'fw-bold fs-3'
    },
    buttonsStyling: false
  })

  function generateSwalOptions(text, icon, options) {
    return {
      text: translate(text ?? ''),
      icon: icon ?? 'success',
      showCancelButton: options?.showCancelButton ?? false,
      backdrop: options?.backdrop ?? true,
      showClass: options?.showClass ?? {
        popup: 'animate__animated animate__slideInDown'
      },
      reverseButtons: options?.reverseButtons ?? true,
      cancelButtonText: translate('Cancel'),
      confirmButtonText:
        options?.confirmButtonText ??
        `<div class="spinner-border text-undefined spinner-border-sm btn-loading-spinner" role="status"><span class="visually-hidden">Loading...</span></div> ${translate('Continue')}`,
      preConfirm: options?.preConfirm || (async () => Promise.resolve())
    }
  }

  const finalOptions = {
    backdrop: entryOptions?.backdrop ?? true,
    showCancelButton: entryOptions?.showCancelButton ?? false,
    cancelButtonText: translate('Cancel'),
    reverseButtons: entryOptions?.reverseButtons ?? true,
    showClass: entryOptions?.showClass ?? {
      popup: 'animate__animated animate__slideInDown'
    },
    confirmButtonText:
      entryOptions?.confirmButtonText ??
      `<div class="spinner-border text-undefined spinner-border-sm btn-loading-spinner" role="status"><span class="visually-hidden">Loading...</span></div> ${translate('Continue')}`,
    preConfirm: entryOptions?.preConfirm || (async () => Promise.resolve())
  }

  // Ejecutar inmediatamente la alerta
  const result = swalModal.fire(generateSwalOptions(entryText, entryIcon, finalOptions))

  // Devolver una función que resuelve la promesa de SweetAlert2
  return () => result
}
